import { render } from "./NoAccess.vue?vue&type=template&id=20cc6ff0&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import "./NoAccess.vue?vue&type=style&index=0&id=20cc6ff0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cc6ff0"]])

export default __exports__